document.addEventListener('DOMContentLoaded', () => {
    
    // --- MOBILE MENU TOGGLE ---
    const navbar = document.getElementById('navbar');
    const menuToggle = document.getElementById('navbar-toggle');
    const navLinks = document.querySelectorAll('.nav-link, .navbar__menu .btn');

    menuToggle.addEventListener('click', () => {
        navbar.classList.toggle('menu-open');
        // Toggle icon
        const icon = menuToggle.querySelector('i');
        if (navbar.classList.contains('menu-open')) {
            icon.classList.remove('fa-bars');
            icon.classList.add('fa-times');
        } else {
            icon.classList.remove('fa-times');
            icon.classList.add('fa-bars');
        }
    });

    // Close menu when clicking a link
    navLinks.forEach(link => {
        link.addEventListener('click', () => {
            navbar.classList.remove('menu-open');
            const icon = menuToggle.querySelector('i');
            icon.classList.remove('fa-times');
            icon.classList.add('fa-bars');
        });
    });

    // --- SMOOTH SCROLLING & ACTIVE LINK ---
    const sections = document.querySelectorAll('section');
    
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                e.preventDefault();
                // Adjust for fixed navbar
                const navbarHeight = 80;
                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    window.addEventListener('scroll', () => {
        let current = '';
        const scrollY = window.pageYOffset;
        
        // Navbar glassmorphism class toggle
        if (scrollY > 50) {
            navbar.classList.add('scrolled');
        } else {
            navbar.classList.remove('scrolled');
        }

        sections.forEach(section => {
            const sectionTop = section.offsetTop - 150;
            const sectionHeight = section.clientHeight;
            if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
                current = section.getAttribute('id');
            }
        });

        navLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === `#${current}`) {
                link.classList.add('active');
            }
        });
    });

    // --- SCROLL REVEAL ANIMATIONS ---
    const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                observer.unobserve(entry.target); // Only animate once
            }
        });
    }, {
        root: null,
        threshold: 0.15, // Trigger when 15% of element is visible
        rootMargin: "0px 0px -50px 0px" // Slightly before it fully enters viewport
    });

    document.querySelectorAll('.reveal-on-scroll').forEach(element => {
        revealObserver.observe(element);
    });

    // --- FORM VALIDATION & SUBMISSION ---
    const contactForm = document.getElementById('contact-form');
    const submitBtn = document.getElementById('submit-btn');
    const formAlert = document.getElementById('form-alert');
    
    // Regex for basic US phone
    const phoneRegex = /^(\+?1)?[\s.-]?\(?[0-9]{3}\)?[\s.-]?[0-9]{3}[\s.-]?[0-9]{4}$/;
    // Basic email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validateInput = (input) => {
        const value = input.value.trim();
        let isValid = true;

        if (input.id === 'name') {
            isValid = value.length >= 3;
        } else if (input.id === 'phone') {
            isValid = phoneRegex.test(value);
        } else if (input.id === 'email') {
            isValid = emailRegex.test(value);
        } else if (input.id === 'address') {
            isValid = value.length >= 10;
        }

        if (isValid) {
            input.classList.remove('is-invalid');
            input.classList.add('is-valid');
            input.nextElementSibling.classList.remove('show');
        } else {
            input.classList.remove('is-valid');
            input.classList.add('is-invalid');
            input.nextElementSibling.classList.add('show');
        }

        return isValid;
    };

    // Real-time validation
    const inputs = contactForm.querySelectorAll('.form-control');
    inputs.forEach(input => {
        input.addEventListener('blur', () => validateInput(input));
        input.addEventListener('input', () => {
            // Only validate on input if it already has a status class
            if (input.classList.contains('is-invalid') || input.classList.contains('is-valid')) {
                validateInput(input);
            }
        });
    });

    contactForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        let formIsValid = true;
        inputs.forEach(input => {
            if (!validateInput(input)) {
                formIsValid = false;
            }
        });

        if (!formIsValid) return;

        // Form is valid, prepare submission
        setLoadingState(true);
        formAlert.className = 'alert'; // Reset alert
        
        const formData = {
            name: document.getElementById('name').value.trim(),
            phone: document.getElementById('phone').value.trim(),
            email: document.getElementById('email').value.trim(),
            address: document.getElementById('address').value.trim(),
        };

        try {
            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    // Only send CSRF if we are using web routes, but for API it's good practice if sanctum is used
                    // Wait, this is an API route so CSRF might not be strictly needed, but let's send it
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (response.ok && data.success) {
                showAlert('success', data.message);
                contactForm.reset();
                inputs.forEach(i => i.classList.remove('is-valid', 'is-invalid'));
            } else {
                // Validation error or other server error
                let errorMsg = 'An error occurred. Please try again.';
                if (data.errors) {
                    errorMsg = Object.values(data.errors).map(err => err.join(', ')).join('<br>');
                } else if (data.message) {
                    errorMsg = data.message;
                }
                showAlert('error', errorMsg);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            showAlert('error', 'A network error occurred. Please try again later.');
        } finally {
            setLoadingState(false);
        }
    });

    const setLoadingState = (isLoading) => {
        const btnText = submitBtn.querySelector('.btn-text');
        const spinner = submitBtn.querySelector('.fa-spinner');
        
        if (isLoading) {
            submitBtn.disabled = true;
            btnText.style.display = 'none';
            spinner.style.display = 'inline-block';
        } else {
            submitBtn.disabled = false;
            btnText.style.display = 'inline-block';
            spinner.style.display = 'none';
        }
    };

    const showAlert = (type, message) => {
        formAlert.innerHTML = message;
        formAlert.className = `alert alert--${type} show`;
        
        // Hide success alert after 5 seconds
        if (type === 'success') {
            setTimeout(() => {
                formAlert.classList.remove('show');
            }, 5000);
        }
    };
});
